/**
 * What the Sidebar Menu Config feature can switch: which sidebar entries, and
 * for which roles. Offering one more entry or role to the Admin is a new line
 * here and the same line in the backend's api/sidebar-menu/sidebar-menu.config.js;
 * keep the two in step.
 */

/** The sidebar entries the Admin can switch off. */
export type TSidebarMenuKey = "dashboard" | "rejected_applications" | "reports";

/** The roles whose sidebar the Admin can change, spelled as they are stored on the user. */
export type TSidebarRole = "Level 1" | "Level 2" | "Level 3";

/** The switched-off entries of each role. An entry that is not listed is shown. */
export type TSidebarHiddenMenus = Record<TSidebarRole, TSidebarMenuKey[]>;

export const SIDEBAR_ROLES: TSidebarRole[] = ["Level 1", "Level 2", "Level 3"];

/** The switchable entries, in the order and with the name the Admin screen lists them. */
export const SIDEBAR_MENU_OPTIONS: { menuKey: TSidebarMenuKey; label: string }[] = [
  { menuKey: "dashboard", label: "Dashboard" },
  { menuKey: "rejected_applications", label: "Rejected Applications" },
  { menuKey: "reports", label: "Reports" },
];
